import {
    CHANGE_BUDGET_LOAD_DATE,
    LOAD_BUDGET,
    START_BUDGET_LOAD,
    CANCEL_BUDGET_LOAD,
} from '../../actions/types';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case START_BUDGET_LOAD:
            return action.payload;
        case CANCEL_BUDGET_LOAD:
            return INITIAL_STATE;
        case CHANGE_BUDGET_LOAD_DATE:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                calced: action.payload.key === 'dateSelection' ? null : state.calced,
            };
        case LOAD_BUDGET:
            if (action.meta.calcOnly) {
                return { ...state, calced: action.payload };
            } else {
                return INITIAL_STATE;
            }
        default:
            return state;
    }
};
